import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-transport-eksternal`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/monitoring-transport-eksternal/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/monitoring-transport-eksternal", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-transport-eksternal/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/monitoring-transport-eksternal/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/monitoring-transport-eksternal/${id}/pdf`,
    "_blank"
  );
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  printPdf,
};
